var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"bem",rawName:"v-bem"},{name:"breakpoints",rawName:"v-breakpoints",value:({
        'size-xs': 0,
        'size-sm': 500,
        'size-md': 900,
        'size-lg': 1200,
        callback: _vm.updateBreakpoints
    }),expression:"{\n        'size-xs': 0,\n        'size-sm': 500,\n        'size-md': 900,\n        'size-lg': 1200,\n        callback: updateBreakpoints\n    }"}]},[_c('side-panel'),_c('entry-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }